import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CircledIconComponent } from './circled-icon.component'

@NgModule({
  declarations: [CircledIconComponent],
  imports: [CommonModule],
  exports: [CircledIconComponent],
})
export class CircledIconModule {}
